module.exports = __webpack_public_path__ + "3afda2cac0bcca6c5801c0139f34c610.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/owl-outline.png
// module id = 558
// module chunks = 0